import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import { artifactStore, subtreeStore, timStore, viewsStore } from "@/hooks";
import {
  PanelCard,
  Typography,
  TextButton,
  FlexBox,
  FlexItem,
  AttributeChip,
} from "@/components/common";


/**
 * Displays information about trace links in the selected matrix.
 */
const __default__ = {
  name: "TraceMatrixTraces",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const traceMatrix = computed(() => timStore.selectedTraceMatrix);

const sourceType = computed(() => traceMatrix.value?.sourceType || "");
const targetType = computed(() => traceMatrix.value?.targetType || "");

const traceLabel = computed(() => {
  const count = traceMatrix.value?.count || 0;

  return count === 1 ? "1 Trace Link" : `${count} Trace Links`;
});

const generatedCount = computed(() => traceMatrix.value?.generatedCount || 0);

const approvedCount = computed(() => traceMatrix.value?.approvedCount || 0);

/**
 * Calculate the percentage of child artifacts of this type
 * that trace to at least one parent artifact of this type.
 */
const traceCoverage = computed(() => {
  const sourceArtifacts = artifactStore.allArtifacts.filter(
    (artifact) => artifact.type === sourceType.value
  );
  const sourceCount = sourceArtifacts.length;
  const traceCount = sourceArtifacts
    .map(({ id }) => subtreeStore.getParents(id))
    .filter((parents) =>
      parents.some(
        (id) => artifactStore.getArtifactById(id)?.type === targetType.value
      )
    ).length;
  const coverage = traceCount / sourceCount;

  return {
    text: `(${traceCount}/${sourceCount})`,
    percentage: coverage,
  };
});

/**
 * Switches to tree view and highlights this type matrix.
 */
function handleViewLevel(): void {
  if (!traceMatrix.value) return;

  viewsStore.addDocumentOfTypes([
    traceMatrix.value.sourceType,
    traceMatrix.value.targetType,
  ]);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PanelCard), {
    title: traceLabel.value,
    collapsable: "",
    borderless: ""
  }, {
    "title-actions": _withCtx(() => [
      _createVNode(_unref(TextButton), {
        text: "",
        small: "",
        label: "View Artifacts",
        icon: "view-tree",
        onClick: handleViewLevel
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(FlexBox), null, {
        default: _withCtx(() => [
          _createVNode(_unref(FlexItem), { parts: "6" }, {
            default: _withCtx(() => [
              _createVNode(_unref(Typography), {
                variant: "caption",
                value: "Generated Trace Links"
              }),
              _createVNode(_unref(Typography), {
                el: "p",
                value: generatedCount.value
              }, null, 8, ["value"]),
              _createVNode(_unref(Typography), {
                variant: "caption",
                value: "Approved Trace Links"
              }),
              _createVNode(_unref(Typography), {
                el: "p",
                value: approvedCount.value
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_unref(FlexItem), { parts: "6" }, {
            default: _withCtx(() => [
              _createVNode(_unref(Typography), {
                variant: "caption",
                value: "Trace Coverage"
              }),
              _createVNode(_unref(FlexBox), { align: "center" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(AttributeChip), {
                    value: traceCoverage.value.percentage,
                    "confidence-score": ""
                  }, null, 8, ["value"]),
                  _createVNode(_unref(Typography), {
                    el: "span",
                    value: traceCoverage.value.text,
                    l: "1"
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})